import React from "react";
import theme from "assets/theme";
// Components
import { Grid } from "@mui/material";
import MKTypography from "components/MKTypography";
// Styled Components
import { StyledImage } from "index.styles";
// Utils
import useMediaQueries from "utils/mediaQueries.utils";
import { StyledInsuranceCoverageContainer } from "./index.styles";

const DynamicInsuranceCoverage = ({ coverageData }) => {
  const { isLg } = useMediaQueries();

  if (!coverageData) {
    return null;
  }

  return (
    <StyledInsuranceCoverageContainer component="section" id="insurance-coverage-section">
      <Grid container spacing={isLg ? 8 : 4}>
        {/* Grid item - why insurance wont cover section */}
        <Grid item xs={12}>
          <Grid container spacing={isLg ? 8 : 4}>
            <Grid item xs={12} lg={6}>
              <StyledImage
                insurance={"true"}
                height={coverageData.image.height}
                width={coverageData.image.width}
                src={coverageData.image.src}
                alt={coverageData.image.alt}
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              <MKTypography component={"h2"} variant={"h2"} gutterBottom>
                <span style={{ color: theme.palette.accent.main }}>{coverageData.whyNotCovered.titleAccent}</span>{" "}
                {coverageData.whyNotCovered.title.replace(coverageData.whyNotCovered.titleAccent, "")}
              </MKTypography>
              {coverageData.whyNotCovered.paragraphs.map((paragraph, index) => (
                <MKTypography
                  key={index}
                  component={"p"}
                  variant={isLg ? "body1" : "body2"}
                  gutterBottom={index === coverageData.whyNotCovered.paragraphs.length - 1}
                >
                  {paragraph}
                </MKTypography>
              ))}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}></Grid>
        {/* Grid item - am i covered section */}
        <Grid item xs={12} textAlign={isLg && "center"}>
          <MKTypography component={"h3"} variant={"h3"} gutterBottom>
            {coverageData.amICovered.titleAccent} <span style={{ color: theme.palette.accent.main }}>Covered?</span>
          </MKTypography>
          {coverageData.amICovered.paragraphs.map((paragraph, index) => (
            <MKTypography
              key={index}
              component={"p"}
              variant={isLg ? "body1" : "body2"}
              gutterBottom={index === coverageData.amICovered.paragraphs.length - 1}
            >
              {paragraph}
            </MKTypography>
          ))}
        </Grid>
      </Grid>
    </StyledInsuranceCoverageContainer>
  );
};

export default DynamicInsuranceCoverage;
